import { Button } from "@/components/Button";
import {
  DataRelationships,
  HowItWorks,
  OutputAndSyncs,
  StatsAndVideo,
} from "@/components/Email/UsageDashboard";

interface IProps {
  data: IGetUsageDashboardRS;
}

const UsageDashboardView = ({ data }: IProps) => {
  return (
    <>
      <div
        className="my-30 rounded bg-white p-5 shadow-md"
        data-testid="usage-dashboard">
        <StatsAndVideo data={data} />
        <HowItWorks />
        <DataRelationships data={data} />
        <OutputAndSyncs data={data} />
      </div>
      <Button as="link" variant="primary" to="/marketing/audit-logs" width="lg">
        See Audit Logs
      </Button>
    </>
  );
};

export default UsageDashboardView;
